import React from 'react'
import {useEffect, useState} from 'react'
import envVariables from '../../data/envVariables'
import Button from '../Button'
import { isDealPreAvinode } from '../../utilities/settings'

const PortalFinanceStageBasedCtas = ({deal, onShowOptions}) => { 
    const legId = deal.daM_Ref
    const briefUrl = `/flight-brief?lo=${legId}`
    const downloadQuoteBriefUrl = `${envVariables.documentBase}/QuotebuilderDownload/download-quotebrief?lo=${legId}`
    const downloadInvoiceUrl = `${envVariables.documentBase}/api/invoice/download-invoice-jsr?legId=${legId}`

    useEffect(() => {
        //console.log(deal)
    }, [deal])

    const openInvoiceDL = () => {
        window.open(downloadInvoiceUrl, '_blank')
    }
    const openPbInvoiceDL = (subInvoiceNumber) => {
        const subInvoiceUrl = `${downloadInvoiceUrl}&subInvoiceNumber=${subInvoiceNumber}`
        window.open(subInvoiceUrl, '_blank')

    }

    return (
        <>
            <div className="portal-cta-grid">   
                {(!isDealPreAvinode(deal)) && <Button classNames={['button button--secondary']} onClick={openInvoiceDL}>Invoice PDF</Button>}
                {(!isDealPreAvinode(deal)) && <Button classNames={['button button--secondary']} onClick={() => openPbInvoiceDL(1)}>PB Invoice 1 PDF</Button>}
                {(!isDealPreAvinode(deal)) && <Button classNames={['button button--secondary']} onClick={() => openPbInvoiceDL(2)}>PB Invoice 2 PDF</Button>}
                {(!isDealPreAvinode(deal)) && <Button classNames={['button button--secondary']} onClick={() => openPbInvoiceDL(3)}>PB Invoice 3 PDF</Button>}
            </div>
            
        </>
    )
}

export default PortalFinanceStageBasedCtas